function assertNever(x: never): never {
  throw new Error('Unexpected type: ' + x);
}

function assertNotAllowed(x: string): never {
  throw new Error('Not allowed type: ' + x);
}
export { assertNever, assertNotAllowed };
